import React from "react";

const CloseIcon = ({ strokeWidth = 1.5, ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M4 20L20 4M20 20L4 4"
      />
    </svg>
  );
};

export const CloseWithCircleIcon = ({
  size = 32,
  fillColor = "none",
  className = "text-[#B4B4B4]",
}) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={fillColor}
        viewBox="0 0 32 32"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.895"
          d="M16 29.333c7.334 0 13.334-6 13.334-13.333S23.334 2.667 16 2.667 2.667 8.667 2.667 16s6 13.333 13.333 13.333M12.227 19.773l7.546-7.546M19.773 19.773l-7.546-7.546"
        />
      </svg>
    </span>
  );
};

export default CloseIcon;
